import { useEffect, useState } from "react";
import { Menu, X, Download } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS, CAPABILITY_DOC_URL } from "../lib/siteData";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 z-50 w-full bg-white/90 backdrop-blur-md transition-all duration-300 ${
        scrolled ? "border-b border-border shadow-[0_1px_0_rgba(2,44,34,0.06)]" : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-6 lg:px-8">
        <a href="#hero" data-testid="nav-logo-link" aria-label="Home">
          <Logo />
        </a>

        <div className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.replace("#", "")}`}
              className="font-body text-sm font-medium text-muted-foreground transition-colors hover:text-forest"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={CAPABILITY_DOC_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-download-btn"
            className="inline-flex items-center gap-2 rounded-full border border-forest/20 px-4 py-2 font-body text-sm font-medium text-forest transition-colors hover:bg-forest-50"
          >
            <Download size={15} /> Capability Doc
          </a>
          <a
            href="#contact"
            data-testid="nav-contact-btn"
            className="rounded-full bg-forest px-5 py-2 font-body text-sm font-semibold text-white transition-colors hover:bg-forest-600"
          >
            Talk to the Consortium
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="text-forest lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-border bg-white px-6 py-4 lg:hidden">
          <div className="flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${link.href.replace("#", "")}`}
                className="font-body text-sm font-medium text-muted-foreground"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-contact-btn"
              className="mt-2 rounded-full bg-forest px-5 py-2.5 text-center font-body text-sm font-semibold text-white"
            >
              Talk to the Consortium
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
